import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=5bcb05e6&scoped=true&"
import script from "./InformationModal.vue?vue&type=script&lang=js&"
export * from "./InformationModal.vue?vue&type=script&lang=js&"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=5bcb05e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb05e6",
  null
  
)

export default component.exports